/* tslint:disable */

declare var Object: any;
export interface ScheduledJobInterface {
  "patientId": string;
  "chainId": string;
  "notificationId": string;
  "scheduledDate": Date;
  "status"?: string;
  "id"?: any;
  "created"?: Date;
}

export class ScheduledJob implements ScheduledJobInterface {
  "patientId": string;
  "chainId": string;
  "notificationId": string;
  "scheduledDate": Date;
  "status": string;
  "id": any;
  "created": Date;
  constructor(data?: ScheduledJobInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ScheduledJob`.
   */
  public static getModelName() {
    return "ScheduledJob";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ScheduledJob for dynamic purposes.
  **/
  public static factory(data: ScheduledJobInterface): ScheduledJob{
    return new ScheduledJob(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ScheduledJob',
      plural: 'ScheduledJobs',
      path: 'ScheduledJobs',
      idName: 'id',
      properties: {
        "patientId": {
          name: 'patientId',
          type: 'string'
        },
        "chainId": {
          name: 'chainId',
          type: 'string'
        },
        "notificationId": {
          name: 'notificationId',
          type: 'string'
        },
        "scheduledDate": {
          name: 'scheduledDate',
          type: 'Date'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
